import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';
import RenderTextFieldRedux from '../Complements/RenderTextFieldRedux';
import { Field, reduxForm } from 'redux-form';
const useStyles = makeStyles(theme => ({
    textField: {
      width: 200,
    },
    margin: {
      margin: theme.spacing(1),
    },
  }));

const DialogPrompt = ( {  onCloseDialogPrompt, openDialogPrompt, pristine, onAcceptClickPrompt, typeText }) => {
    const classes = useStyles();
    let valueProp = ''
    const [value, setValue] = React.useState(valueProp);
    const handleChange = event => {
      setValue(event.target.value);
    };
    const handleOk = () => {
        onAcceptClickPrompt(value)
        onCloseDialogPrompt()
      // onClose(value);
    };
    
    return (
        
            <Dialog
                open={ openDialogPrompt }
                onClose={ onCloseDialogPrompt }
                fullWidth={true}
                maxWidth= 'xs'
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{ 'Ingrese descripcion' }</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                    </DialogContentText>
                    <Field
                        withFocus
                        name="description"
                        id="description"
                        required
                        value={value}
                        className={clsx(classes.margin, classes.textField)}
                        onChange={handleChange}
                        component={ RenderTextFieldRedux }
                        label="Descripción"
                        type={ typeText }
                        fullWidth
                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        color="primary"
                        disabled={pristine}
                        onClick = {() => { handleOk() }}
                        style={{borderLeft: '3px solid rgba(255, 198, 0)'}}
                        fullWidth>
                        Aceptar
                    </Button>
                    <Button onClick={ onCloseDialogPrompt } color="primary"  style={{borderLeft: '3px solid rgba(255, 198, 0)'}}>
                        Cancelar
                    </Button>
                </DialogActions>
        </Dialog>
      
    );
};

DialogPrompt.propTypes = {
    // PayType: PropTypes.func.isRequired,
    onCloseDialogPrompt: PropTypes.func.isRequired,
    openDialogPrompt: PropTypes.bool.isRequired,
    onAcceptClickPrompt: PropTypes.func.isRequired,
    typeText: PropTypes.string.isRequired,
}

const PromptReduxForm = reduxForm(
  {
    form: 'PropmtForm'
  }
)(DialogPrompt)

export default PromptReduxForm;